import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative h-screen min-h-[900px] flex items-end pb-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0bccc0a14fa21f0bfdb15904928c1da5.jpg"
          alt="Concrete pumping in Western North Carolina"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/20"></div>
      </div>

      <div className="absolute left-0 top-0 bottom-0 w-2 bg-yellow-500"></div>

      <div className="absolute top-8 right-8 flex flex-col gap-3 items-end">
        <div className="bg-yellow-500 text-black px-6 py-3 rounded-full font-bold text-sm tracking-wide whitespace-nowrap flex items-center gap-2">
          <i className="ri-medal-fill text-base"></i>
          VETERAN OWNED BUSINESS
        </div>
        <div className="bg-black/70 border border-yellow-500 text-yellow-500 px-6 py-3 rounded-full font-bold text-sm tracking-wide whitespace-nowrap">
          24/7 AVAILABLE
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-3xl">
          <div className="text-yellow-500 text-sm font-bold tracking-widest mb-6">
            OTTO, NC | SERVING WNC, N. GA & SW SC
          </div>

          <div className="bg-white/95 backdrop-blur-sm p-8 rounded-lg mb-8 inline-block">
            <h1 className="text-6xl md:text-7xl font-bold text-black leading-tight mb-4">
              EXPERT CONCRETE<br />PUMPING & STONE<br />SERVICES
            </h1>
          </div>

          <p className="text-xl text-white font-light mb-10 max-w-2xl">
            Reliable solutions for residential and commercial projects in Western North Carolina
          </p>

          <div className="flex flex-wrap gap-4">
            <Link
              to="/services"
              className="bg-yellow-500 text-black px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-all flex items-center gap-3 cursor-pointer whitespace-nowrap"
            >
              REQUEST A QUOTE
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
            <Link
              to="/about"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-black transition-all cursor-pointer whitespace-nowrap"
            >
              VIEW PORTFOLIO
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce cursor-pointer">
        <span className="text-yellow-500 text-xs font-semibold tracking-wider">EXPLORE SERVICES</span>
        <i className="ri-arrow-down-line text-yellow-500 text-2xl"></i>
      </div>

      <div className="absolute bottom-8 right-8 w-20 h-20 flex items-center justify-center">
        <i className="ri-truck-line text-yellow-500 text-5xl animate-pulse"></i>
      </div>
    </section>
  );
};

export default HeroSection;